import React, { useState } from "react";
import Classes from "./AppointmentTabs.module.css";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function VehicleDetails({ booking }) {
  const [expanded, setExpanded] = useState('panel0');
  const vehicles = booking?.vehicles || [];

  const fuelMap = { reg: "Regular (87 Octane)", mid: "Diesel ", prem: "Premium (91-93 Octane)" };

  return (
    <section className={Classes.panel}>
      <h3 className={Classes.title}>Vehicle Details</h3>

      {vehicles.length === 0 && <div className={Classes.muted}>No vehicles on this booking.</div>}

      {vehicles.map((v, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={(_, isExp) => setExpanded(isExp ? `panel${index}` : false)}
          sx={{ border: 'none', boxShadow: 'none', mb: '10px', '&:before': { display: 'none' } }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`vh-${index}`}>
            <div className={Classes.AccordionHeader}><h5>{`Vehicle ${index + 1}`}</h5></div>
          </AccordionSummary>
          <AccordionDetails className={Classes.accordinBody}>
            <div className={Classes.row}><p className={Classes.label}>Vehicle Make</p><p className={`${Classes.value} ${Classes.muted}`}>{v.make || '—'}</p></div>
            <div className={Classes.row}><p className={Classes.label}>Vehicle Model</p><p className={`${Classes.value} ${Classes.muted}`}>{v.model || '—'}</p></div>
            <div className={Classes.row}><p className={Classes.label}>License Plate</p><p className={`${Classes.value} ${Classes.muted}`}>{v.license || '—'}</p></div>
            <div className={Classes.row}><p className={Classes.label}>Fuel Type</p><p className={`${Classes.value} ${Classes.muted}`}>{fuelMap[v.fuelTypeId] || '—'}</p></div>
            <div className={Classes.row}><p className={Classes.label}>Requested Fuel Amount</p><p className={`${Classes.value} ${Classes.muted}`}>{v.requestedAmount ? `${v.requestedAmount} Gallons` : '—'}</p></div>
          </AccordionDetails>
        </Accordion>
      ))}
    </section>
  );
}
